import {required} from "vuelidate/lib/validators";  
const satdosyazarfacmakontrol = {
    data() { 
      return {   
        satdosyazarfacmakontrolData: { 
          Teslimyeri: "",
          Teslimtarihi: "", 
          Yapilacagiyer: "",
          Ihaletarihsaati: "",
          Ihalekayitnumarasi: "",
          Istenilenbelgeler: [],
          Dosyaid: "",  
          }, 
          FormDataType:{
            Teslimyeri:{FieldName:"Teslimyeri",Field:"input",FieldTitle:this.$t('satdosyazarfacmakontrol.AddEdit.Teslimyeri'),FieldType:"text"},
            Teslimtarihi:{FieldName:"Teslimtarihi",Field:"input",FieldTitle:this.$t('satdosyazarfacmakontrol.AddEdit.Teslimtarihi'),FieldType:"text"},
            Yapilacagiyer:{FieldName:"Yapilacagiyer",Field:"input",FieldTitle:this.$t('satdosyazarfacmakontrol.AddEdit.Yapilacagiyer'),FieldType:"text"},
            Ihaletarihsaati:{FieldName:"Ihaletarihsaati",Field:"input",FieldTitle:this.$t('satdosyazarfacmakontrol.AddEdit.Ihaletarihsaati'),FieldType:"text"},
            Ihalekayitnumarasi:{FieldName:"Ihalekayitnumarasi",Field:"input",FieldTitle:this.$t('satdosyazarfacmakontrol.AddEdit.Ihalekayitnumarasi'),FieldType:"text"},
            Istenilenbelgeler:{FieldName:"Istenilenbelgeler",Field:"combobox",FieldTitle:this.$t('satdosyazarfacmakontrol.AddEdit.Istenilenbelgeler'),ComboDataArray:[]}, 
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Teslimyeri: { required},  
        Teslimtarihi: { required }, 
        Yapilacagiyer: { required },  
        Ihaletarihsaati: { required },  
        Ihalekayitnumarasi: { required },  
        Istenilenbelgeler: { required } 
      },
      
 
  },
  created(){ 
      this.ActionsSabitGet(1559).then(res => {  
        for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Istenilenbelgeler.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Value})
          }    
      }); 
  }

}
export default satdosyazarfacmakontrol